'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trackAttribution;

var _storage = require('./storage');

var _urls = require('./urls');
/* global window */


var DEFAULT_ATTRIBUTION_DATA = {
  source: '(direct)',
  medium: '(not set)',
  campaign: '(not set)',
  content: '(not set)',
  term: '(not set)',
  widgetId: '(not set)'
};

function getReferrerData(domain, referrer) {
  var siteHostName = (0, _urls.getHostName)(domain);
  var referrerHostName = (0, _urls.getHostName)(referrer);

  if (!referrer || referrer === '' || siteHostName === referrerHostName) {
    return {};
  }

  return {
    source: referrerHostName,
    medium: 'referral',
    content: referrer
  };
}

function getCampaignData(params) {
  if (params.utm_source) {
    return {
      source: params.utm_source,
      medium: params.utm_medium || DEFAULT_ATTRIBUTION_DATA.medium,
      campaign: params.utm_campaign || DEFAULT_ATTRIBUTION_DATA.campaign,
      content: params.utm_content || DEFAULT_ATTRIBUTION_DATA.content,
      term: params.utm_term || DEFAULT_ATTRIBUTION_DATA.term
    };
  } else if (params.lm_source) {
    return {
      source: params.lm_source,
      medium: params.lm_medium || DEFAULT_ATTRIBUTION_DATA.medium,
      campaign: params.lm_campaign || DEFAULT_ATTRIBUTION_DATA.campaign,
      content: params.lm_content || DEFAULT_ATTRIBUTION_DATA.content,
      term: params.lm_term || DEFAULT_ATTRIBUTION_DATA.term
    };
  }

  return {};
}

function getWidgetData(params) {
  if (!params.referringWidgetId) {
    return {};
  }

  return {
    widgetId: params.referringWidgetId
  };
}

function getAttributionData(window) {
  var _getLocation = (0, _urls.getLocation)(window),
      domain = _getLocation.domain,
      href = _getLocation.href,
      referrer = _getLocation.referrer;

  var params = (0, _urls.getParams)(href);
  return Object.assign({}, DEFAULT_ATTRIBUTION_DATA, getReferrerData(domain, referrer), getCampaignData(params), getWidgetData(params));
}
/**
 * Sets the attribute cookie with campaign and referrer information.
 * This roughly follows the collection & processing methods used by
 * Google Analytics: https://support.google.com/analytics/answer/6205762
 * @param options {object}
 */


function trackAttribution(_ref) {
  var _ref$storageName = _ref.storageName,
      storageName = _ref$storageName === undefined ? 'lm_tracker_ref' : _ref$storageName,
      _ref$overrideAttribut = _ref.overrideAttribution,
      overrideAttribution = _ref$overrideAttribut === undefined ? false : _ref$overrideAttribut;
  var prevAttributionData = (0, _storage.getSessionData)(storageName);
  var newAttributionData = getAttributionData(window);
  var attributionData = void 0;

  if (!prevAttributionData || overrideAttribution && newAttributionData.medium !== DEFAULT_ATTRIBUTION_DATA.medium) {
    attributionData = newAttributionData;
  } else {
    attributionData = prevAttributionData;
  }

  (0, _storage.setSessionData)(storageName, attributionData);
}